import { render, staticRenderFns } from "./AreaDivision.vue?vue&type=template&id=45a7fe68&scoped=true"
import script from "./AreaDivision.vue?vue&type=script&lang=js"
export * from "./AreaDivision.vue?vue&type=script&lang=js"
import style0 from "./AreaDivision.vue?vue&type=style&index=0&id=45a7fe68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a7fe68",
  null
  
)

export default component.exports